import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { PaymentMethodListWrapper } from './payment-methods-list/PaymentMethodList';
import { useIntl } from 'react-intl';

const PaymentMethodsPage = () => {
  const intl = useIntl();

  const paymentMethodsBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'PAYMENT_METHOD_PAGE.BREADCRUMB' }),
      path: '/apps/payment-methods-management/payment-methods',
      isSeparator: false,
      isActive: false,
    },
    { title: '', path: '', isSeparator: true, isActive: false },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='payment-methods'
          element={
            <>
              <PageTitle breadcrumbs={paymentMethodsBreadcrumbs}>
                {intl.formatMessage({ id: 'PAYMENT_METHOD_PAGE.TITLE' })}
              </PageTitle>
              <PaymentMethodListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/payment-methods-management/payment-methods' />} />
    </Routes>
  );
};

export default PaymentMethodsPage;
